import React from 'react';
import NewsBanner from './NewsBanner';
import NewsHeader from './NewsHeader';
import NewsBody from './NewsBody';
import NewsTags from './NewsTags';
import CompanyPercentage from './CompanyPercentage';
import { useNewsCardData } from './useNewsCardData';
import { useNewsCardClick } from './useNewsCardClick';
import { buttonResetStyles } from './newsCardStyles';
import type { BaseNewsCardProps } from './types';

const HorizontalNewsCard: React.FC<BaseNewsCardProps> = ({
  newsItem,
  onClick,
  showContent = false,
  showTags = false,
  showCompanies = true,
  className = '',
  aemImages,
  timestampLabels,
}) => {
  const data = useNewsCardData(newsItem, aemImages);
  const { handleClick } = useNewsCardClick({
    newsId: (newsItem as any)?.id ?? "",
    onClick,
    newsHeading: data.title,
    componentPosition: (newsItem as any)?.id?.toString() ?? "",
  });

  return (
    <button
      onClick={handleClick}
      aria-label={`View news: ${data.title}`}
      className={`flex gap-4 min-w-[320px] min-h-[106] md:w-[860px] md:min-h-[102px] bg-white border border-[#E5E5E5] rounded p-3 md:px-4 md:py-3 items-center cursor-pointer transition-colors ${className}`}
      style={buttonResetStyles}
    >
      <NewsBanner
        bannerLink={data.bannerLink}
        title={data.title}
        className="w-[60px] h-[60px] md:w-[72px] md:h-[72px] object-cover rounded shrink-0"
        aemImages={aemImages}
      />
      <div className="flex-1">
        <NewsBody
          title={data.title}
          content={data.content}
          showContent={showContent}
          titleClassName="mb-2"
        />
        <div className="flex items-center gap-2 text-xs">
          {showCompanies && data.companies && data.companies.length > 0 && data.companies[0]?.percentage != null && (
            <CompanyPercentage company={data.companies[0]} />
          )}
          <NewsHeader
            sourceName={data.sourceName}
            sourceLogo={data.sourceLogo}
            timestamp={data.timestamp}
            aemImages={aemImages}
            timestampLabels={timestampLabels}
          />
        </div>
        {showTags && data.tags && data.tags.length > 0 && (
          <NewsTags tags={data.tags} className="mt-2" />
        )}
      </div>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-black shrink-0 hidden md:block"
        aria-hidden="true"
      >
        <path
          d="M12 8L20 16L12 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default HorizontalNewsCard;

